import formatNumber from "format-number"
import I18n from "shared/i18n"

/**
 * * Formats a number according to the current locale
 * @param {number} number
 * @param {object} args
 * @returns {string} The formatted number
 */
export default function numberFormat(number, args) {
  const formatOptions = {
    decimal: I18n.t("number.currency.format.separator"),
    integerSeparator: I18n.t("number.currency.format.delimiter")
  }

  if (args?.decimals) number = number.toFixed(args.decimals)

  return formatNumber(formatOptions)(number)
}
